import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import { DotsSixVerticalIcon } from '@phosphor-icons/react/DotsSixVertical';

import { Checkbox } from '../../../Checkbox/Checkbox.tsx';

export const StyledCheckbox = styled(Checkbox)`
  padding-right: 0;
`;

export const StyledDragHandleIcon = styled(DotsSixVerticalIcon)`
  /* MUI DragIndicator rendered at its default 24px; Phosphor 1em would follow the MenuItem font size. */
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  cursor: grab;
`;

export const StyledMenuItem = styled(MenuItem)`
  gap: ${({ theme }) => theme.spacing(1.5)};
`;
